import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { MagazineAdapter } from '@modules/content-api/adapter/magazine.adapter';
import { ContentAPIService } from '@modules/content-api/content-api.service';

import { MAGAZINE_PAGE_PARAMS } from './magazine-page.service';

@Injectable({
  providedIn: 'root',
})
export class TopicPageService {
  private apiService = inject(ContentAPIService);
  private magazineAdapter = inject(MagazineAdapter);

  public getTopicPage(fullPath: string) {
    return this.apiService
      .getResources('topic_pages', MAGAZINE_PAGE_PARAMS.append('filter[slug.value]', `/topic-page${fullPath}`))
      .pipe(
        map((data) => {
          try {
            return this.magazineAdapter.parse(data[0] ?? null);
          } catch {
            return null;
          }
        })
      );
  }
}
